import SpinnerFilter from './SpinnerFilter'

export default {
  components: {
    SpinnerFilter
  },
  methods: {
    
  },
  props: {
    loading: { type: Boolean, default: false }
  }
}
